import type { KPIRequest } from "@/types/kpiTypes.ts"

export const LWRNKPIs: KPIRequest[] = [
  {
    $type: "calc",
    name: "Raw Inlet Gas per Minute",
    unit: "SCFM",
    expression: "[60] / 1.44",
    aggFunction: "Average",
    location: 5,
  },
  {
    $type: "basic",
    id: 60,
    location: 5,
  },
  {
    $type: "basic",
    id: 65,
    location: 5,
    padding: 32,
  },
  {
    $type: "basic",
    id: 61,
    location: 5,
  },
  {
    $type: "calc",
    name: "Uptime",
    unit: "%",
    aggFunction: "Average",
    location: 5,
    expression: "[110]/24*100",
    padding: 32,
  },
  {
    $type: "calc",
    name: "Efficiency",
    unit: "%",
    aggFunction: "Average",
    typeId: 1,
    location: 5,
    preAggregate: true,
    expression: "if([80]>0,[80],[70]) / ([61] * ([110] / 24)) * 100",
    padding: 32,
  },
  { $type: "basic", id: 80, location: 5 },
  { $type: "basic", id: 70, location: 5 },

  {
    $type: "basic",
    id: 55,
    location: 5,
  },
]
